import { useCallback, useEffect, useState } from 'react';
import { useAuth, useLocale } from '../context';
import { api } from '../api';
import { EMPTY_RESPONSIBLE_LIMITS } from '../utils/responsibleLimits';

export function useResponsibleLimits() {
  const { token } = useAuth();
  const _locale = useLocale();
  const tr = _locale.t;
  const [limits, setLimits] = useState(EMPTY_RESPONSIBLE_LIMITS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const loadLimits = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const data = await api.responsibleLimits(token);
      setLimits(data);
    } catch {
      setLimits(EMPTY_RESPONSIBLE_LIMITS);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadLimits();
  }, [loadLimits]);

  const saveLimits = async (type, patch) => {
    setSaving(true);
    setErr('');
    setMsg('');
    try {
      const data = await api.updateResponsibleLimits(token, { type, limits: patch });
      setLimits(data);
      setMsg(tr('account.responsible.saved'));
      return true;
    } catch (error) {
      setErr(error.message);
      return false;
    } finally {
      setSaving(false);
    }
  };

  return {
    limits,
    loading,
    saving,
    msg,
    err,
    setMsg,
    setErr,
    saveLimits,
    reload: loadLimits,
  };
}
